import tAction from './action.vue';

export default {
  install(instance: any) {
    instance.component('tAction', tAction);
  },
};
